import { Component } from '@angular/core';
import { FixedBoxControlService } from 'src/app/services/fixed-box-control/fixed-box-control.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.freeplay.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent {
  addFixedBoxPadding: boolean = false;
  lottoId = environment.lottery.lot_id;

  constructor(private _fixedBoxControl: FixedBoxControlService) {
    this.setFixedBox();
  }

  setFixedBox(): void {
    this._fixedBoxControl.isFixedBoxShowed$.subscribe((isShowed) => {
      this.addFixedBoxPadding = isShowed;
    });
  }
}
